import { FuelIcon } from "@/shared/icons";

type Props = {
  name: string;
  src: string;
};

export default function GasStationHeader({ name, src }: Props) {
  return (
    <div
      className="flex items-center justify-end relative w-full h-[6.25rem] rounded-bl-[1rem] bg-white px-[1.875rem]"
      style={{
        backgroundImage: `url(${src})`,
        backgroundSize: "cover",
      }}
    >
      <div className="flex items-center text-16 font-medium text-white gap-1.5">
        {name}
        <FuelIcon size={24} />
      </div>
    </div>
  );
}
